import LvRipple from './Ripple.js';
export default LvRipple;
